import $ from 'jquery';
import { getError } from './helpers';
import JSOG from 'jsog';

export default class ImportDAO {
  constructor(urls) {
    this.RECRUITS_IMPORT_URL = urls.RECRUITS_IMPORT_URL;
    this.SCHOOL_SOURCES_IMPORT_URL = urls.SCHOOL_SOURCES_IMPORT_URL;
  }

  /**
   * Do a recruits import using the formdata passed in
   * @param formData
   * @returns {*}
   */
  recruits({ formData }) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.RECRUITS_IMPORT_URL,
        data: formData,
        processData: false,
        contentType: false,
        type: 'POST'
      }).then((recruitImportData) => {
        resolve(JSOG.decode(recruitImportData));
      }, (jqXhr) => {
        reject(getError(jqXhr, 'Failed to import recruits.'));
      });
    });
  }

  schoolSources({ formData = null }) {
    return new Promise((resolve, reject) => {
      if (formData === null) {
        reject(new Error('FormData is required'));
      }

      $.ajax({
        url: this.SCHOOL_SOURCES_IMPORT_URL,
        data: formData,
        processData: false,
        contentType: false,
        type: 'POST'
      }).then((matchData) => {
        resolve(JSOG.decode(matchData));
      }, (jqXhr) => {
        reject(getError(jqXhr, 'Failed to fetch match data for schools in CSV'));
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dao/ImportDAO.js